/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Brand_Badge_Line21Inputs */

const vi_sitesettings_brand_badge_line21 = /** @type {(inputs: Sitesettings_Brand_Badge_Line21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng 2`)
};

/**

* @param {Sitesettings_Brand_Badge_Line21Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_brand_badge_line21 = /** @type {((inputs?: Sitesettings_Brand_Badge_Line21Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Brand_Badge_Line21Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_brand_badge_line21(inputs)
});
export { sitesettings_brand_badge_line21 as "siteSettings_brand_badge_line2" }